module.exports = __webpack_public_path__ + "media/hyper/images/barcode-496de09092c361eb70b77fab3c53c817.png";